import Lang from "lang.js";
import messages from "./messages";

export default new Lang({ messages });